import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  constructor(
    private _http: HttpClient
  ) {
  }

  public getAPI<T>(path: string, params?: HttpParams): Observable<T> {
    return this._http.get<T>(`${environment.apiUrl}/${path}`, { params: params });
  }

  public postAPI<T>(path: string, body: any): Observable<T> {
    console.log(body);
    return this._http.post<T>(`${environment.apiUrl}/${path}`, body)
      .pipe(first());
  }

}
